export const DATASHEETS_MODULE_NAME = {
  editor: 'editor',
  home: 'home',
  result: 'result'
};